module.exports = __webpack_public_path__ + "static/media/quebon-song-bgm-high-vol.c93df005.mp3";